import {useContext, useEffect, useState} from 'react'
import axios from 'axios'
import { Link, useNavigate } from 'react-router-dom'
import { useMsal } from '@azure/msal-react'
import {urlValue, unfolder, validContext, useTranslate} from '../lib'
import logo1 from '../logos/ai-nesting-studio.svg';
import logo2 from '../logos/ai-nesting-studio-2.svg';
import icon_home from '../images/home.svg'
import icon_management_access from '../images/management_access.png'
import icon_manual from '../images/manual.svg'
import icon_bell from '../images/bell-white.svg'
import icon_minimize from '../images/minimize-white.svg'
import { Tooltip, } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import '../styles/titleBar.scss'
import LanguageSelector from './LanguageSelector';
import ReactModal from 'react-modal';

export default function TitleBar() {
  const [isValid, setIsValid] = useContext(validContext)
  const navigate = useNavigate()
  const { instance } = useMsal()
  const { name, last_name } = JSON.parse(localStorage.getItem('infoUser')) || {
    id: undefined,
  }
  const user = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey');
  const [notifications, setNotifications] = useState([]);
  const [showList, setShowList] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState(null);
  const { t } = useTranslate();
  const logos = {
    'ai-nesting-studio.svg': logo1,
    'ai-nesting-studio-2.svg': logo2,
  };

  const logout = e => {
    localStorage.clear()
    sessionStorage.clear()
    setIsValid(false)
    instance.logoutPopup().catch(error => console.log(error))
    
  }
  function delete_cookie(name) {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }
  
  useEffect(() => {
    ReactModal.setAppElement('#root');
    getNotifications();
    fetchCustomization();
  }, []);

  const getNotifications = async () => {
    try {
      const id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
      const token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
      const res = await axios.get(`${urlValue}/studio/release-notification`, {
        headers: { user: id, 'access-token': token }
      });
      setNotifications(res.data.slice(0, 20));
    } catch (error) {
      console.error(error);
    }
  };

  const fetchCustomization = async () => {
    try {
      const token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
      // const res = await axios.get(`${urlValue}/studio/campaign-interface-customizations/user-last-campaign/${user.id}`, {
      //   headers: { user: user.id, 'access-token': token }
      // });
      // console.log('=======res:', res)
      // if (res.data && res.data.customization) {
      //   const expires = new Date();
      //   expires.setTime(expires.getTime() + (7 * 24 * 60 * 60 * 1000)); // 7 días
      //   document.cookie = `campaign_customization=${encodeURIComponent(JSON.stringify(res.data.customization))};expires=${expires.toUTCString()};path=/`;
      // }
    } catch (error) {
      console.error('No se pudo obtener la personalización de campaña:', error);
    }
  };

  const openNotification = (n) => {
    setSelectedNotification(n);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedNotification(null);
  };

  return (
    <>
      <header style={{
          boxShadow: '0px 3px 6px #00000029',
      }}>
        <Link to={'/'}>
            {(() => {
              const getCookie = (name) => {
                const cookie = document.cookie.split('; ').find(row => row.startsWith(name + '='));
                return cookie ? JSON.parse(decodeURIComponent(cookie.split('=')[1])) : null;
              };

              const customization = getCookie('campaign_customization');
              const selectedLogo = customization?.logo || 'ai-nesting-studio.svg';
              const logoToUse = logos[selectedLogo] || logo1;

              return (
                <img id='home1-tp' className="logo" src={logoToUse} alt="Logo" />
              );
            })()}
            <Tooltip anchorId="home1-tp" content={t('common.goToHome')} place="top" />
        </Link>
        <div className="header-options">
            <div className="d-flex flex-row align-items-center">
                <Link id='home-tp' to={`/`} style={{marginRight: 15}}>
                    <div><img src={icon_home} style={{width: 30}} alt="Bell Icon" /></div>
                </Link>
                <Tooltip style={{fontSize: 13, maxWidth: 160}}
                    anchorId="home-tp" content={t('common.goToHome')} place="top" />
                {/* className='buttonH' */}
                <Link id='project-access' to={'/project-access'} style={{marginRight: 15}}>
                  <div><img src={icon_management_access} style={{width: 30}} alt="Bell Icon" /></div>
                </Link>
                <Tooltip anchorId="project-access" content={t('menu.projectAccess')} place="top" />
                <a download href='/icons/MANUALNESTING.pdf'  id='guide-tp' to={`.`} style={{marginRight: 15}}>
                    <div><img src={icon_manual} style={{width: 30}} alt="Gear Icon" /></div>
                </a>
                <Tooltip style={{fontSize: 13, maxWidth: 200}}
                    anchorId="guide-tp" content={t('menu.downloadUserManual')}  place="top" />                
                <Tooltip style={{fontSize: 13, maxWidth: 160}} anchorId="report-tp" content={t('reports.reports')}  place="top" />
                <div onClick={()=>{logout()}} id='logout-tp' to={`/project-reports`} style={{marginRight: 15, cursor: "pointer"}}>
                    <div><img src='/icons/logout-icon.svg' style={{width: 30}} alt="Gear Icon" /></div>
                </div>
                <Tooltip anchorId="logout-tp" content={t('menu.logout')}  place="top" />
            </div>
            <div style={{marginRight: 15}}>
                <LanguageSelector className="header-language-selector" />
            </div>
            <div className="d-flex flex-column" style={{marginLeft: 5}}>
              <div style={{fontWeight: 'bold', fontSize: 16, color: '#707070', whiteSpace: 'nowrap', fontFamily: 'principal-font'}}>
                  {user.name + ' ' + user.last_name}
              </div>
              <div style={{fontSize: 15, marginTop: -5, color: '#707070', fontFamily: 'principal-font-light'}}>
                  {user.role === 1 ? t('common.admin') : ''}
                  {user.role === 2 ? t('common.manager') : ''}
                  {user.role === 3 ? t('common.editor') : ''}
                  {user.role === 4 ? t('common.reader') : ''}
              </div>
            </div>

            {/*<div className="userIcon"></div>*/}
            {/*<div className="userInfo">*/}
            {/*    <p className="name">{name}</p>*/}
            {/*    <p className="title">{last_name}</p>*/}
            {/*</div>*/}
            {/*<div className="logout ml-3" onClick={logout}>*/}
            {/*    <img src="/icons/logout.png" alt="Logout" />*/}
            {/*</div>*/}
        </div>
      </header>

      {/* Botón flotante */}
      <div style={{
        position: 'fixed',
        bottom: 20,
        left: 20,
        zIndex: 999,
      }}>
        <button
          style={{
            padding: '10px 10px',
            borderRadius: 30,
            backgroundColor: '#0038A8',
            color: 'white',
            border: 'none',
            cursor: 'pointer',
            boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
          }}
          onClick={() => setShowList(!showList)}
        >
          <img
            src={showList ? icon_minimize : icon_bell}
            alt="toggle"
            style={{ width: 20, height: 20 }}
          />
        </button>

        {showList && (
          <div style={{
            marginTop: 10,
            backgroundColor: '#fff',
            border: '1px solid #ccc',
            borderRadius: 10,
            maxHeight: 300,
            width: 250,
            overflowY: 'auto',
            boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
            padding: 10
          }}>
            {/*<h4 style={{ margin: '5px 0', fontSize: 16 }}>Últimas 20</h4>*/}
            {notifications.length === 0 ? (
              <p style={{ fontSize: 14 }}>{t('menu.noNotification')} </p>
            ) : (
              notifications.map((n, idx) => (
                <div key={idx} style={{
                  padding: '10px 0',
                  borderBottom: '1px solid #eee',
                  fontSize: 14
                }}>
                  <div style={{display: 'flex', flexDirection:'row', justifyContent: 'space-between'}}>
                    <span style={{fontSize: 11, color: '#4d4d4d'}}><strong>{n.title}</strong></span><br />
                    <button
                      onClick={() => openNotification(n)}
                      title={t('common.maximize') || 'Maximizar'}
                      style={{
                        flexShrink: 0,
                        width: 32,
                        height: 32,
                        borderRadius: 6,
                        border: '1px solid #dcdcdc',
                        background: '#fff',
                        cursor: 'pointer',
                        textAlign: 'center',
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    >
                      <div style={{margin: 'auto'}}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                          width="22" height="22" aria-hidden="true">
                          <path d="M5 9V5h4M15 19h4v-4" fill="none" stroke="#333" strokeWidth="2" strokeLinecap="round" />
                          <path d="M9 5H5m0 0v4M19 15v4m0 0h-4" fill="none" stroke="#333" strokeWidth="2" strokeLinecap="round"/>
                        </svg>
                      </div>
                    </button>
                  </div>
                  
                  
                  <span style={{fontSize: 11, color: '#4d4d4d'}}>{n.description}</span>
                </div>
              ))
            )}
          </div>
        )}
      </div>
      <ReactModal
        isOpen={modalOpen}
        onRequestClose={closeModal}
        style={{
          overlay: { backgroundColor: 'rgba(0,0,0,0.45)', zIndex: 1000 },
          content: {
            maxWidth: '600px',
            width: '90%',
            inset: '50% auto auto 50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: '12px',
            padding: '20px',
            border: '1px solid #e6e6e6'
          }
        }}
        contentLabel="Notification detail"
      >
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
          <h3 style={{margin: 0}}>{selectedNotification?.title}</h3>
          <button onClick={closeModal} style={{border: 'none', background: 'transparent', fontSize: 20, cursor: 'pointer'}}>×</button>
        </div>
        <div style={{marginTop: 10, fontSize: 14, color: '#444'}}>
          {selectedNotification?.description}
        </div>
      </ReactModal>
    </>
  )
}
